'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Module 0
 * Contains all the Milestones on the sidebar
 * Contains all activites on the sidebar
 * Each Milestone is called a Task and is 1 component
 * Eg. Module1Task1, Module1Task2 etc...
 * This is so that we can better format the content
 */
var Module0 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, module: state.modules, moduleData: state.moduleData.data };
}, { changeItem: _modules.changeItem }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0, _Component);

  function Module0() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0.__proto__ || (0, _getPrototypeOf2.default)(Module0)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 0,
      showModal: false,
      appItems: [{
        id: 1,
        title: 'Introduction',
        favi: 'fa fa-star-o',
        component: _react2.default.createElement(_components.Module0App1, null)
      }, {
        id: 2,
        title: 'Food Pyramid',
        favi: 'fa fa-photo',
        component: _react2.default.createElement(_components.Module0App2, null)
      }, {
        id: 3,
        title: 'Importance of healthy eating',
        favi: 'fa fa-star-o',
        component: _react2.default.createElement(_components.Module0App3, null)
      }, {
        id: 4,
        title: 'Your goals',
        favi: 'fa fa-graduation-cap',
        component: _react2.default.createElement(_components.Module0App4, null)
      }, {
        id: 5,
        title: 'Barriers',
        favi: 'fa fa-graduation-cap',
        component: _react2.default.createElement(_components.Module0App5, null)
      }],
      extraItems: [{
        id: 1,
        title: 'Statistics',
        favi: 'fa fa-bar-chart',
        component: _react2.default.createElement(_components.Module0Extra1, null)
      }, {
        id: 2,
        title: 'Difficulties of healthy eating',
        favi: 'fa fa-star-o',
        component: _react2.default.createElement(_components.Module0Extra2, null)
      }],
      activityItems: [],
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // contains the items in the sidebar
  // these are appItems, extraItems, activityItems
  // we also keep the different types in here too
  // index id's by 1, so it matches up with Module2AppX convention


  // checkCompleted = () => {
  //   if (this.props.moduleData['module' + this.state.moduleId].isCompleted === false) {
  //     return false;
  //   }

  //   const obj = this.state;
  //   obj.showModal = true;
  //   this.setState(obj);
  //   return true;
  // }

  (0, _createClass3.default)(Module0, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('../../Modules.scss');
      var moduleId = this.state.moduleId;

      var medal = require('../../Profile/Assets/medal0.png');

      return _react2.default.createElement(
        'div',
        { className: styles.modulesPage },
        _react2.default.createElement(_components.ModulesSidebar, { core: this.state.appItems,
          extra: this.state.extraItems,
          activities: this.state.activityItems,
          module: 0, modtype: this.props.module[moduleId].modtype,
          item: this.props.module[moduleId].item,
          changeItem: this.props.changeItem,
          moduleData: this.props.moduleData }),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 2, sm: 3, xs: 2, lg: 2 },
          '\xA0'
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 10, sm: 9, xs: 9, lg: 10 },
          this.state.appItems.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: 'app' + index },
              _this2.props.module[moduleId].modtype === _this2.state.types.app && _this2.props.module[moduleId].item === index + 1 && item.component
            );
          }),
          this.state.extraItems.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: 'extra' + index },
              _this2.props.module[moduleId].modtype === _this2.state.types.extra && _this2.props.module[moduleId].item === index + 1 && item.component
            );
          }),
          this.state.activityItems.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: 'act' + index },
              _this2.props.module[moduleId].modtype === _this2.state.types.activity && _this2.props.module[moduleId].item === index + 1 && item.component
            );
          })
        )
      );
    }
  }]);
  return Module0;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  module: _propTypes2.default.object,
  changeItem: _propTypes2.default.func.isRequired,
  moduleData: _propTypes2.default.object
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Module0;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Modules/0/Module.js
// module id = 1276
// module chunks = 0